import { createStore } from 'vuex';

const store = createStore({
  state() {
    return {
      isLoader: false,  // default loader state
    };
  },
  mutations: {
    setLoader(state, status) {
      state.isLoader = status;
    },
  },
  actions: {
    toggleLoader({ commit }, status) {
      commit('setLoader', status);
    },
  },
});

export default store;
